import { useBlogManagerAPIInterface } from "@dealer-center/ddc-pages-blog-manager-fetch";
import { Box, Button, TextInput } from "@dealer-center/core-components";
import { useMemo, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";

export const PagesBlogManagerUiInput = () => {
  const { searchValue: searchValueFromParams } = useParams();
  const [searchValue, setSearchValue] = useState(searchValueFromParams || "");
  const [submittedSearchValue, setSubmittedSearchValue] = useState(
    searchValueFromParams || ""
  );
  const memoizedSearchValue = useMemo(
    () => submittedSearchValue,
    [submittedSearchValue]
  );
  const { isLoading } = useBlogManagerAPIInterface({
    searchValue: memoizedSearchValue
  });
  const navigate = useNavigate();
  const submitSearch = () => {
    setSubmittedSearchValue(searchValue);
    navigate(searchValue);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "flex-end"
        }}
      >
        <TextInput
          id="PagesBlogManagerUiTextInput"
          label="Search"
          name="PagesBlogManagerUiTextInput"
          placeholder="Enter search value"
          value={searchValue}
          onChange={e => setSearchValue(e.target.value)}
          onKeyDown={e => {
            if (e.key === "Enter") {
              submitSearch();
            }
          }}
        />
        <Button
          analyticsConfiguration={{
            eventName: "PagesBlogManagerUi Search"
          }}
          buttonStyle="primary"
          disabled={!searchValue}
          isLoading={isLoading}
          onClick={() => submitSearch()}
        >
          Search
        </Button>
      </Box>
      <Outlet />
    </>
  );
};
